<template>
  <!-- OU, BTTS -->
  <!-- <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][ouBetType]"> -->
  <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]">
    <div data-template="template5" class="wrap-template template5">
      <div class="main-handicap m-ou">
        <div class="vrow items-center template-title is_fold">
          <div class="play-name col" @click="showLeg()">
            <span class="ellipsis">
              {{ getTitleCaption() }}
            </span>
          </div>
          <div class="" v-if="newAllBetEvent.sprbinfo"><span class="ellipsis">{{ sportTableLang.table['SPORT_TABLE.CURRENT_TOTAL'] }}: {{ newAllBetEvent.sprbinfo.scoa }}-{{ newAllBetEvent.sprbinfo.scob }}</span></div>
          <div style="width: 37px;" @click="setToTop($event)">
            <span class="set_top" style="display: none;">
              <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
            </span>
          </div>
        </div>
        <template v-if="show">
          <div class="vrow sub-title-1">
            <span style="width: 25%;"></span>
            <span style="width: 37.5%; text-align: center;">{{ sportAllBetLang['ALL_BET.LBL_OVER'] }}</span>
            <span style="width: 37.5%; text-align: center;">{{ sportAllBetLang['ALL_BET.LBL_UNDER'] }}</span>
          </div>
          <!-- <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][ouBetType]).length)"> -->
          <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][bettyp]).length)">
            <template
              v-if="newAllBetEvent.od[plytyp][bettyp][Object.keys(newAllBetEvent.od[plytyp][bettyp])[subMatchKey]]">
              <!-- <template
              v-if="newAllBetEvent.od[plytyp][ouBetType][Object.keys(newAllBetEvent.od[plytyp][ouBetType])[subMatchKey]]"> -->
              <div class="handicap">
                <div class="handicap-item sub-title-2 yb-family-odds">
                  <!-- <over-under :event="newAllBetEvent" :plyType="plytyp" :betType="ouBetType" :match="subMatchKey" /> -->
                  <over-under :event="newAllBetEvent" :plyType="plytyp" :betType="bettyp" :match="subMatchKey" />
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <!-- up/down : odds updown-->
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap" style="display:none">
                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                          <span class="handicap-more" style="display: none;">&nbsp;</span>
                          <div class="ellipsis"></div>
                        </div>
                      </div>
                      <odd :event="newAllBetEvent" :team="teamA" :plyType="plytyp" :betType="bettyp"
                        :match="subMatchKey" :ref="'teamOver' + subMatchKey" :mode="'ab'" :wdth="wdth" />
                      <!-- up/down : odds updown-->
                      <!-- <div class="odds odds-ou yb-number-font">
                        <div class="">
                          <span class="yb-family-odds yb-number-bold match_details">
                          </span>
                        </div>
                      </div> -->
                      <!-- 
                        <div class="odds">
                          <span></span>
                          <div class="odds-arrows-wrap">
                            <div class="odds-icon odds-up"></div>
                            <div class="odds-icon odds-down"></div>
                          </div>
                        </div>  
                        -->
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap" style="display:none">
                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                          <span class="handicap-more" style="display: none;">&nbsp;</span>
                          <div class="ellipsis"></div>
                        </div>
                      </div>
                      <!-- <odd :event="newAllBetEvent" :team="teamB" :plyType="plytyp" :betType="ouBetType"
                              :match="subMatchKey" :ref="'teamUnder' + subMatchKey" /> -->
                      <odd :event="newAllBetEvent" :team="teamB" :plyType="plytyp" :betType="bettyp"
                        :match="subMatchKey" :ref="'teamUnder' + subMatchKey" :mode="'ab'" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template> <!-- END submatch -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd'
import OverUnderComponents from '../../../components/over-under'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null,
    wdth: $('.betitem').width()
  },
  data() {
    return {
      btypes: [allBetMixin.data().ouBetType, allBetMixin.data().rouBetType],
      show: true,
      shdp: ['7', '8', '9', '10', '11', '12'],  //set playtype
      gamePt: ['14', '15', '16', '17', '18'],  //game 1-5 playtype
      pt: {
        7: '1',
        8: '2',
        9: '3',
        10: '4',
        11: '5',
        12: '6',
      },
      gamePtLang: {
        '14': '1',
        '15': '2',
        '16': '3',
        '17': '4',
        '18': '5',
      }
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption() {
      var a = ''
      var pt = ''
      var bt = ''
      var sCapt = ''
      if (this.plytyp == this.ftPlyType) {
        a = '_FT'
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H'
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H'
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP'
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP'
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP'
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') { /*** Set ***/
        a = '_' + this.pt[this.plytyp] + 'SET'
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') { /*** Game ***/
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME'
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS'
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS'
      }else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS'
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS'
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS'
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS'
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS'
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS'
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS'
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS'
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS'
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME'
      }

      // Play Type
      pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a]

      //  Bet Type
      if (jQuery.inArray(this.bettyp, ['2', '9']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.SUBHEADER_OU']
      } else if (jQuery.inArray(this.bettyp, ['46', '47']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.HTG']
      } else if (jQuery.inArray(this.bettyp, ['48', '49']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.ATG']
      } else if (jQuery.inArray(this.bettyp, ['32','33']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.SUBHEADER_BTTS']
      } else if (jQuery.inArray(this.bettyp, ['80','81']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.HTR']
      } else if (jQuery.inArray(this.bettyp, ['82','83']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.ATR']
      }

      if (this.isSpecial) {
        var st = this.specialLeagueCaption(this.newAllBetEvent, this.bettyp)
        sCapt = ' '+ st + ' (' + this.sportAllBetLang['ALL_BET.LBL_SPECIALS'] + ')'
      }

      return pt + bt + sCapt
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(d) {
      this.$parent.setToTop(d);
    },
    addToMyMarket(plytyp, ouBetType) {
      if (this.selectMarket)
        this.selectMarket(this.newAllBetEvent, plytyp, ouBetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, ouBetType) {
      if (this.removeMarket)
        this.removeMarket(this.newAllBetEvent, plytyp, ouBetType, this.isSpecial)
    },
    // oddsHeader() {
    //   var retCapt = ''
    //   if (this.isSpecial) {
    //     retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.ouBetType)
    //   }

    //   return retCapt
    // },
  },
  mounted(){
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }else{
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-ou.vue